import { useCallback, useMemo, useState } from "react";
import { useAppSnackbar } from "../../../../Hooks/useAppSnackbar";
import { InputMoney } from "../../../../Components/Atoms/InputMoney";
import { SelectOptionButtons } from "../../../../Components/Atoms/SelectOptions";
import { formatCurrency, convertToCents } from "../../../../Utils/formatters";
import { VOUCHER_CATEGORY_DEFS } from "./voucherCategories";

export const VoucherTransferForm = ({
  fromCategory,
  balances,
  onTransfer,
  onSuccess,
}) => {
  const { enqueueSnackbar } = useAppSnackbar();
  const [toCategoryId, setToCategoryId] = useState("");
  const [amountInput, setAmountInput] = useState("0");

  const destinationOptions = useMemo(
    () =>
      VOUCHER_CATEGORY_DEFS.filter((cat) => cat.id !== fromCategory.id).map(
        (cat) => ({
          key: cat.id,
          title: cat.label,
          icon: cat.icon,
        })
      ),
    [fromCategory.id]
  );

  const handleAmountChange = useCallback((value) => {
    setAmountInput(String(value ?? "0"));
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!toCategoryId) {
      enqueueSnackbar("Selecione a caixinha de destino.", { variant: "warning" });
      return;
    }

    const amountCents = convertToCents(amountInput);

    if (amountCents <= 0) {
      enqueueSnackbar("Informe um valor válido.", { variant: "warning" });
      return;
    }

    const sourceBalance = balances[fromCategory.id] ?? 0;

    if (amountCents > sourceBalance) {
      enqueueSnackbar("Saldo insuficiente nesta caixinha.", { variant: "error" });
      return;
    }

    const destination = VOUCHER_CATEGORY_DEFS.find((cat) => cat.id === toCategoryId);
    const success = onTransfer({
      fromId: fromCategory.id,
      toId: toCategoryId,
      amountCents,
    });

    if (success) {
      enqueueSnackbar(
        `Transferido ${formatCurrency(amountCents)} de ${fromCategory.label} para ${destination?.label}.`,
        { variant: "success" }
      );
      setToCategoryId("");
      setAmountInput("0");
      onSuccess?.();
    }
  };

  const selectedDestination = VOUCHER_CATEGORY_DEFS.find(
    (cat) => cat.id === toCategoryId
  );

  return (
    <form className="cartoes-voucher-transfer" onSubmit={handleSubmit}>
      <div className="cartoes-voucher-transfer__field">
        <p className="cartoes-voucher-transfer__label">Origem</p>
        <div className="cartoes-voucher-transfer__origin">
          <p className="cartoes-voucher-transfer__origin-title">{fromCategory.label}</p>
          <p className="cartoes-voucher-transfer__origin-balance">
            {formatCurrency(fromCategory.balanceCents)} disponível
          </p>
        </div>
      </div>

      <div className="cartoes-voucher-transfer__field">
        <p className="cartoes-voucher-transfer__label">Destino</p>
        <SelectOptionButtons
          isSelectable
          defaultOption={toCategoryId}
          options={destinationOptions}
          columnsDesktop={3}
          columnsMobile={2}
          refreshOptionSelected={setToCategoryId}
        />
        {selectedDestination && (
          <p className="cartoes-voucher-transfer__hint">
            Saldo em {selectedDestination.label}:{" "}
            {formatCurrency(balances[selectedDestination.id] ?? 0)}
          </p>
        )}
      </div>

      <div className="cartoes-voucher-transfer__field">
        <p className="cartoes-voucher-transfer__label">Valor da transferência</p>
        <InputMoney refreshValue={handleAmountChange} />
      </div>

      <button type="submit" className="btn-primary cartoes-voucher-transfer__submit">
        Transferir entre caixas
      </button>
    </form>
  );
};
